import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import { cn } from '@/utils/cn';

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'p', 'br', 'ul', 'ol', 'li', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

/**
 * Renders notice/update HTML. The API already sanitises it; this second pass
 * keeps the page safe even if a bad row ever got into the database.
 */
export function IssueRichText({ html, className }: { html: string; className?: string }) {
  const clean = useMemo(() => DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR }), [html]);
  return (
    <div
      className={cn('prose-sm max-w-none text-[14px] text-[var(--text-content-title)] [&_a]:text-[var(--color-forest)] [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5', className)}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
